import { createSlice } from "@reduxjs/toolkit";

const initialStateVerification = {
  email: null,
  passport: null,
  otpToken: null,
  otpTokenExpAt: null,
  name: null,
  timeslotId: null,
  apptDateTime: null,
  haveCpfAccountNumber: null,
}

const initialState = {
  ack: null,
  ...initialStateVerification
};

export const appointmentSlice = createSlice({
  name: "xAppointment",
  initialState,
  reducers: {
    ack: (state, { payload }) => {
      return { ...state, ack: payload };
    },
    idTypeChooseNext: (state, { payload }) => {
      return { ...state, haveCpfAccountNumber: payload };
    },
    verifyNext: (state, { payload }) => {
      const { email, passport, otpToken, otpTokenExpAt } = payload;
      return { ...state, email, passport, otpToken, otpTokenExpAt };
    },
    appointmentNext: (state, {payload}) => {
      const { name, timeslotId, apptDateTime } = payload;
      return {...state, name, timeslotId, apptDateTime }
    },
    clear: (state) => {
      // clear all
      return { ...initialState };
    },
    clearVerification: (state) => {
      // clear all except ack & haveCpfAccountNumber
      const {haveCpfAccountNumber} = state;
      return { ...state, ...initialStateVerification, haveCpfAccountNumber };
    },
    clearIdTypeChoose: (state) => {
      // clear all except ack
      return { ...state, ...initialStateVerification };
    },
    clearAppointment: (state) => {
      return {...state, timeslotId: null, apptDateTime: null }
    },
    updateOtpToken: (state, { payload }) => {
      return { ...state, otpToken: payload };
    },
    updateOtpTokenExpAt: (state, { payload }) => {
      return { ...state, otpTokenExpAt: payload };
    },

  }
});

export const { ack, idTypeChooseNext, verifyNext, clear, clearIdTypeChoose, clearVerification, appointmentNext, clearAppointment, updateOtpToken, updateOtpTokenExpAt  } = appointmentSlice.actions;

export default appointmentSlice.reducer;
